<header class="w-100 h-100">
  <button class="close-side-bar" (click)="closeSideBar()">
    <app-icon icon="close" class="close-icon"></app-icon>
  </button>
  <nav class="f-col h-100 justify-content-between" role="navigation">
    @if ((isContractSigned$ | async) || (isImpersonating())) {
      <div class="top f-col g-4">
        <div class="heading d-flex p-4 align-items-center">
          <img class="serve-logo" src="assets/Logo.png" alt="LU Serve Logo">
          <div class="role-text x-small-reg-text">CSER SUPERVISOR</div>
        </div>
        @if (opportunities$ | async; as opportunities) {
          <div>
            @if (organizations.length > 0 || opportunities.length > 0) {
              <div class="my-sections f-col">
                @if (organizations.length > 0) {
                  <div class="nav-list f-col">
                    <div class="d-flex justify-content-between title align-items-center">
                      <div class="xx-small-gray-text">My Organizations</div>
                      <app-icon icon="plus" class="plus small-icon" [routerLink]="['/','supervisor','organization','add']" matTooltip="Request a new organization."></app-icon>
                    </div>
                    @for (org of organizations; track org.organizationId) {
                      <div class="opportunity d-flex" routerLinkActive="active-page" (keydown.enter)="navigateToOrgWithKeyboard(org)" [routerLink]="org.route">
                        <div class="logo-and-name d-inline-flex align-items-center gap-2">
                          <!--PHASE 2              <img class="org-img" src="assets/icons/LU.jpg" alt="">-->
                          <div class="small-medium-text" [ngClass]="org.status === OrganizationStatus.ACTIVE ? '' : 'not-active-organization'">{{org.name}}</div>
                          @if (orgStatusDisplay(org.status); as statusLabel) {
                            <div class="status-tag x-small-medium-text">{{statusLabel}}</div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
                @if ((opportunities$! | async)!.length > 0) {
                  <div class="nav-list f-col">
                    <div class="title xx-small-gray-text">My Opportunities: {{currentOppTerm | term}}</div>
                    @for (opp of (opportunities$! | async); track opp) {
                      <div class="opportunity d-flex align-items-center gap-2" routerLinkActive="active-page" (keydown.enter)="navigateToOppWithKeyboard(opp.id)" [routerLink]="getOppRoute(opp)">
                        <div class="logo-and-name d-flex align-items-center gap-2">
                          <!--PHASE 2              <img class="org-img" src="assets/icons/LU.jpg" alt="">-->
                          <div class="small-medium-text d-flex align-items-center gap-2">
                            <span>{{opp.name}}</span>
                            @if (getActionItemCount(opp.id) > 0) {
                              <span class="badge rounded-circle text-white notification-badge">
                                {{ getActionItemCount(opp.id) }}
                              </span>
                            }
                          </div>
                          @if (opp.status !== OpportunityStatus.ACTIVE) {
                            <div class="status-tag x-small-medium-text">{{oppStatusDisplay(opp.status)}}</div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (isPastTermRegistrationFeatureEnabled | async) {
                  <div class="opportunity" routerLinkActive="active-page">
                    <button class="link-button small-bold-text d-flex gap-2 align-items-center border-0 p-0"
                      [routerLink]="['/', 'supervisor', 'past-term-registration-requests']"
                      [attr.aria-label]="pastTermRegistrationButtonAriaLabel()">
                      <app-icon icon="history" class="xxxxl-icon"></app-icon>
                      <span>Past Term Registration</span>
                      @if (pastTermRegistrationRequestCount) {
                        <span class="badge rounded-circle text-white notification-badge">
                          {{ pastTermRegistrationRequestCount }}
                        </span>
                      }
                    </button>
                  </div>
                }
                <div class="opportunity" routerLinkActive="active-page">
                  <button class="link-button small-bold-text d-flex gap-2 align-items-center border-0 p-0" [routerLink]="['/', 'supervisor', 'past-opportunities']">
                    <app-icon icon="history" class="xxxxl-icon"></app-icon>
                    <span>Past Opportunities</span>
                    @if (actionItemsForPastOpportunitiesCount) {
                      <span class="badge rounded-circle text-white notification-badge">
                        {{ actionItemsForPastOpportunitiesCount }}
                      </span>
                    }
                  </button>
                </div>
      <div class="opportunity" routerLinkActive="active-page">
            <button class="link-button small-bold-text d-flex gap-2 align-items-center border-0 p-0" [routerLink]="['/', 'supervisor', 'future-opportunities']">
              <app-icon icon="future" class="large-icon"></app-icon>
              <span>Future Opportunities</span>
              @if (actionItemsForFutureOpportunitiesCount) {
                <span class="badge rounded-circle text-white notification-badge">
                  {{ actionItemsForFutureOpportunitiesCount }}
                </span>
              }
            </button>
          </div>        </div>
            } @else {
              <div class="nav-list f-col">
                <div class="title">
                  <div class="xx-small-gray-text">My Organizations</div>
                </div>
                <div class="new-org">
                  <button class="custom-button-large-primary-dark-blue new-org-button" [routerLink]="['/','supervisor','organization','add']">New Organization Request</button>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
    <div class="footer f-col p-4">
      <div class="supervisor-details d-flex align-items-center gap-3">
        <!--PHASE 2        <img src="assets/images/user.jpg" alt="No photo provided" class="supervisor-picture">-->
        <div class="contact-info text-center f-col gap-1 overflow-hidden">
          <div class="supervisor-name medium-bold-text text-wrap text-break">{{userName}}</div>
          <a href="mailto:{{userEmail}}" class="email small-email-text">{{userEmail}}</a>
        </div>
      </div>
      @if ((isContractSigned$ | async) || (isImpersonating())) {
        <button class="supervisor-button custom-button-large-secondary small-medium-text gap-2" [routerLink]="['/', 'supervisor', 'edit-profile']">
          <app-icon icon="edit" class="edit-icon small-icon"></app-icon>
        Edit Profile</button>
      }
      @if ((isContractSigned$ | async) || (isImpersonating())) {
        <button class="supervisor-button logOut custom-button-large-secondary small-medium-text" [routerLink]="['/', 'student-dashboard']">Student</button>
      }
      @if (isAdmin$ | async) {
        <button class="supervisor-button logOut custom-button-large-secondary small-medium-text" [routerLink]="['/','admin']">Admin</button>
      }
      <button class="supervisor-button logOut custom-button-large-secondary small-medium-text" (click)="logOut()">Log Out</button>

      <div class="f-row justify-content-center pt-3">
        <app-icon icon="help-circle" class="large-icon pe-1"></app-icon>
        <p class="small-bold-text g-2"> Need Help?
          <a target="_blank" rel="noopener noreferrer" href="https://www.liberty.edu/osd/lu-serve/cser/tutorials/supervisors/" class="external-link">CSER Tutorials</a>
        </p>
      </div>
    </div>
  </nav>
</header>
